import React, { useState } from 'react';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';

//import images
import { Link } from 'react-router-dom';
import { AppDispatch, RootState } from 'store';
import Avatar from 'react-avatar';
import AgencyDropdown from './AgencyDropdown';
import { toggleNotificationPreferencesModal } from 'slices/ui/reducer';

const HeaderProfileDropdown = () => {

    const user = useSelector((state: RootState) => state.auth.user);
    const dispatch: AppDispatch = useDispatch();

    //Dropdown Toggle
    const [isProfileDropdown, setIsProfileDropdown] = useState(false);
    const toggleProfileDropdown = () => {
        setIsProfileDropdown(!isProfileDropdown);
    };
    return (
        <React.Fragment>
            <Dropdown isOpen={isProfileDropdown} toggle={toggleProfileDropdown} direction='down'>
                <DropdownToggle tag="button" type="button" className="btn p-0">
                    <span className="d-flex align-items-center">
                        <Avatar size='40' maxInitials={1} round={'0.475rem'} name={user?.name} />
                    </span>
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-end profile-dropdown mt-1">
                    <div className="p-3 py-2 d-flex align-items-center gap-3">
                        <Avatar size='40' maxInitials={1} round={'0.475rem'} name={user?.name} />
                        <div className="d-flex flex-column gap-2">
                            <span className='profile-dropdown-name text-truncate'>{user?.name}</span>
                            <span className='profile-dropdown-email text-truncate'>{user?.username}</span>
                        </div>
                    </div>
                    <div className="dropdown-divider"></div>
                    <DropdownItem className='p-0'>
                        <span onClick={() => dispatch(toggleNotificationPreferencesModal(true))} className="dropdown-item">
                            <i
                                className="mdi mdi-bell text-muted fs-16 align-middle me-1"></i> <span
                                    className="align-middle">Notification Preferences</span>
                        </span>
                    </DropdownItem>
                    <DropdownItem className='p-0'>
                        <Link to="/logout" className="dropdown-item">
                            <i
                                className="mdi mdi-logout text-muted fs-16 align-middle me-1"></i> <span
                                    className="align-middle" data-key="t-logout">Logout</span>
                        </Link>
                    </DropdownItem>
                </DropdownMenu>
            </Dropdown>
        </React.Fragment>
    );
};

export default HeaderProfileDropdown;